import { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { MessageCircle } from 'lucide-react';

import { api } from '@/lib/api';
import { useSocketEvent } from '@/lib/useSocket';

/** Acceso a los mensajes privados, con el número de no leídos. */
export function MessagesButton() {
  const [unread, setUnread] = useState(0);

  useEffect(() => {
    api
      .get<{ unread: number }>('/messages/no-leidos')
      .then((data) => setUnread(data.unread))
      .catch(() => undefined);
  }, []);

  useSocketEvent<{ unread: number }>('message:new', (event) => setUnread(event.unread));
  useSocketEvent<{ unread: number }>('message:read', (event) => setUnread(event.unread));

  return (
    <Link
      to="/mensajes"
      className="btn btn-icon border-white/15 bg-white/[0.08] text-white hover:bg-white/15 hover:text-white relative transition-all hover:scale-105 active:scale-95"
      aria-label={unread ? `Mensajes (${unread} sin leer)` : 'Mensajes'}
    >
      <MessageCircle size={18} />
      {unread > 0 ? (
        <span className="absolute -right-0.5 -top-0.5 flex min-w-4 items-center justify-center rounded-full bg-brand px-1 text-[10px] font-semibold text-white">
          {unread > 9 ? '9+' : unread}
        </span>
      ) : null}
    </Link>
  );
}
